import axios from 'axios';

export const getAddressByLatLng: (
  lat: string,
  lng: string,
) => Promise<any> = async (lat, lng) => {
  const key = process.env.LOCALSTITCH_DEV_GOOGLE_API_KEY;
  const url = `https://maps.googleapis.com/maps/api/geocode/json?language=ko&latlng=${lat}, ${lng}&key=${key}&result_type=street_address`;

  const { results } = await axios.get(url).then(res => res.data);

  return results[0].formatted_address;
};

export const getDistanceFromLatLonInKm = (
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
): number => {
  const deg2rad = deg => {
    return deg * (Math.PI / 180);
  };

  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};
